import { differenceInCalendarDays, isBefore } from 'date-fns';

import { DeliveryStatus } from '../components/report-view/delivery-status';
import { JobWithoutTasks } from '../hooks/use-query-jobs-without-tasks';

export const getTurnaroundDays = (
  completedDate: Date | null | undefined,
  startDate: Date | null | undefined
) => {
  if (completedDate && startDate) {
    let result = differenceInCalendarDays(completedDate, startDate);

    // the minimum turnaround days is 0.
    if (result < 0) {
      return 0;
    }

    return result;
  }
};

export const getJobsAvgTurnaroundDays = (completedJobs: JobWithoutTasks[]) => {
  let jobsWithAvgTurnaround = 0;
  let totalTurnaroundDays = 0;

  for (let job of completedJobs) {
    const turnaroundDays = getTurnaroundDays(job.completedDate, job.startDate);

    if (turnaroundDays !== undefined) {
      jobsWithAvgTurnaround = jobsWithAvgTurnaround + 1;
      totalTurnaroundDays = totalTurnaroundDays + turnaroundDays;
    }
  }

  if (jobsWithAvgTurnaround !== 0) {
    return Math.ceil(totalTurnaroundDays / jobsWithAvgTurnaround);
  }
};

export const getDeliveryStatus = (
  completedDate: Date | null | undefined,
  dueDate: Date | null | undefined
): DeliveryStatus | undefined => {
  if (completedDate && dueDate) {
    const isOnSameDay = differenceInCalendarDays(completedDate, dueDate) === 0;

    if (isBefore(completedDate, dueDate) || isOnSameDay) {
      return 'On time';
    } else {
      return 'Late';
    }
  }
};

export const getJobsDeliveryStatusCount = (
  completedJobs: JobWithoutTasks[]
) => {
  let result = { onTime: 0, late: 0, exception: 0 };

  for (let job of completedJobs) {
    switch (getDeliveryStatus(job.completedDate, job.dueDate)) {
      case 'On time':
        result.onTime = result.onTime + 1;
        break;
      case 'Late':
        result.late = result.late + 1;
        break;
      default:
        result.exception = result.exception + 1;
    }
  }

  return result;
};
